import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { Reveal, ChapterTag, SectionTitle, EASE } from "./Reveal";

export function Faq() {
  const { content } = useSite();
  const faqs = content?.faqs || [];
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 bg-navy-900 blueprint-grid">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <ChapterTag number="10" label="FAQ" />
        <div className="mb-12">
          <SectionTitle>Pertanyaan yang <span className="text-ice">Sering Diajukan</span></SectionTitle>
        </div>
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.id || i} delay={0.03 * i}>
                <div data-testid={`faq-item-${i}`} className={`border rounded-sm transition-colors duration-200 ${isOpen ? "border-ice/50 bg-navy-950" : "border-glacier/15 bg-navy-950/50"}`}>
                  <button
                    data-testid={`faq-question-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                  >
                    <span className="font-semibold text-frost text-sm sm:text-base">{f.question}</span>
                    <Plus className={`w-5 h-5 shrink-0 text-ice transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`} />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: EASE }}
                        className="overflow-hidden"
                      >
                        <p className="px-6 pb-6 text-sm text-steel leading-relaxed" data-testid={`faq-answer-${i}`}>{f.answer}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
